import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-verkaufsartwerkstatt-list-view',
  imports: [],
  templateUrl: './verkaufsartwerkstatt.list-view.html',
  styleUrls: ['./verkaufsartwerkstatt.list-view.css'],
})
export class VerkaufsartwerkstattListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
